import EntityListShell from "./EntityListShell";
import { TextField, deText } from "./fields";
import { translateFields } from "@/lib/adminContentApi";

function emptyForm() {
  return { year: "", title: "", place: "" };
}

function toFormState(item) {
  return { year: item.year || "", title: deText(item.title), place: deText(item.place) };
}

async function buildPayload(form) {
  const { en = {}, fr = {} } = await translateFields({ title: form.title, place: form.place });
  const ml = (key, fallback) => ({ de: fallback, en: en[key] || fallback, fr: fr[key] || fallback });
  return {
    year: form.year,
    title: ml("title", form.title),
    place: ml("place", form.place),
  };
}

export default function EducationEditor() {
  return (
    <EntityListShell
      collection="education"
      title="Ausbildung"
      description="Ausbildungsstationen. Reihenfolge per Pfeiltasten änderbar."
      newLabel="Ausbildung hinzufügen"
      testidBase="edu-admin"
      emptyForm={emptyForm}
      toFormState={toFormState}
      buildPayload={buildPayload}
      renderRowSummary={(item) => (
        <div>
          <div className="font-mono text-xs text-[var(--gold)]">{item.year}</div>
          <div className="text-[var(--text-0)] font-display">{deText(item.title)}</div>
          <div className="text-xs text-[var(--text-2)]">{deText(item.place)}</div>
        </div>
      )}
      renderFields={(form, setForm) => (
        <div className="space-y-4">
          <TextField
            label="Zeitraum / Jahr"
            testid="edu-year"
            value={form.year}
            onChange={(v) => setForm({ ...form, year: v })}
            placeholder="z. B. 10/2011 – 03/2017"
            required
          />
          <TextField label="Titel / Abschluss" testid="edu-title" value={form.title} onChange={(v) => setForm({ ...form, title: v })} required />
          <TextField label="Institution" testid="edu-place" value={form.place} onChange={(v) => setForm({ ...form, place: v })} required />
        </div>
      )}
    />
  );
}
